/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.retail.events.controllers', [])

.controller('RetailEventsController', ['$scope', function($scope) {

    $scope.retailEvents = {

      model: {},

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.retailEvents.init();

}]);